import { SiFarcaster } from "react-icons/si"

export default function FarcasterIconClient({
  fcUsername,
}: {
  fcUsername: string
}) {
  return (
    <a
      href={`https://farcaster.xyz/${fcUsername}`}
      target="_blank"
      rel="noreferrer"
    >
      <SiFarcaster className="h-5 w-5 full-muted-foreground hover:fill-slate-700 transition-all" />
    </a>
  )
}
